<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <!-- Above every layout: a chunk can fail on a `layout: false` page too.
         A chunk error that is *fatal* replaces this file with `error.vue`,
         which renders the same screen. -->
    <V3AppConnectionError v-if="chunkError" />
  </div>
</template>

<script lang="ts" setup>
import { useChunkError } from '~/composables/v3/useChunkError'

const chunkError = useChunkError()
</script>



<style >
body {
    overscroll-behavior: contain;
}
</style>
